import React from 'react'
import dayjs from 'dayjs'

import Horizontal from '../layouts/Horizontal.jsx'
import PieChartHOC from '../charts/PieChartHOC.jsx'
import Card from '../components/Card.jsx'
import ZeroState from '../components/ZeroState.jsx'
import { pretty } from '../../helpers/pretty.js'
import { largestRemainderRound } from '../../charts/helpers/formatters.js'

import { getSocialDistribution, RANGE_TYPES } from '_services/insights-v2.js'
import useRequest from '../hooks/useRequest.js'
import { BE_SOCIAL_CHANNELS } from '../../constants/slidesSchema.js'

const TWO_DAYS_AGO = dayjs().subtract(2, 'day').toISOString().split('T').at(0)
const ONE_MONTH_AGO = dayjs().subtract(1, 'month').subtract(2, 'day').toISOString().split('T').at(0)
const LAST_MONTH_TIME_RANGE = {
  type: RANGE_TYPES.CUSTOM,
  beginning: ONE_MONTH_AGO,
  end: TWO_DAYS_AGO,
}

const format = (data, selectedChannels = []) => {
  if (!data) return []

  const socialNetworks = Object.entries(data).filter(([channel]) =>
    selectedChannels.includes(channel)
  )

  const totalCount = socialNetworks.reduce((total, [_, { count }]) => total + count, 0)

  const rounded = largestRemainderRound(
    socialNetworks.map(([key, { count }]) => (count / totalCount) * 100)
  )

  const formatted = socialNetworks.map(([key], index) => {
    const thisPercent = rounded[index]
    return {
      key: `${pretty(BE_SOCIAL_CHANNELS[key.toLowerCase()])} (${thisPercent}%)`,
      value: thisPercent,
      hideValue: thisPercent < 5,
    }
  })

  formatted.sort((a, b) => (a.value < b.value ? 1 : -1))

  return formatted
}

const PreferredSocialChannels = (props) => {
  const {
    audience: { _id: audienceId },
  } = props
  const { title, description, section_1, selected_channels } = props.data

  const { data } = useRequest(
    getSocialDistribution,
    { audienceId, timeRange: LAST_MONTH_TIME_RANGE },
    true
  )

  const socialData = format(data, selected_channels)

  return (
    <Horizontal
      title={title}
      description={description}
      page={props.index + 1}
      content={() => (
        <Card title={section_1.title} description={section_1.subtitle} showBorder={false}>
          <ZeroState condition={socialData.length >= 4} placeholder="Add at least 4 channels.">
            <PieChartHOC data={socialData} legendPosition="right" />
          </ZeroState>
        </Card>
      )}
    />
  )
}

export default PreferredSocialChannels
